import React, { useContext } from "react";
import { ProjectContext } from "../ProjectContext";
import { RycIsProjectModule } from "../../Enums/RycIsProjectModule";

export interface UseProject {
    currentModule: RycIsProjectModule;
    setCurrentModule: (module: RycIsProjectModule) => void;
    menuButtons: React.ReactNode | null;
    setMenuButtons: (buttons: React.ReactNode | null) => void;
    moduleName: string;

}

export const useProject = (): UseProject => {
    const { currentModule, setCurrentModule, menuButtons, setMenuButtons, moduleName } = useContext(ProjectContext);
    return { currentModule, setCurrentModule, menuButtons, setMenuButtons, moduleName };
};